module.exports = __webpack_public_path__ + "img/frame-advice-s.0903222c.png";